import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyAoOd_LCjDiavniU5LwdrsWsvUMbrPbc4I',
  authDomain: 'messenger-clone-msch.firebaseapp.com',
  databaseURL: 'https://messenger-clone-msch.firebaseio.com',
  projectId: 'messenger-clone-msch',
  storageBucket: 'messenger-clone-msch.appspot.com',
  messagingSenderId: '71899893064',
  appId: '1:71899893064:web:edb8c46bb8132224c0777d',
  measurementId: 'G-128XBY43WH',
});

const db = firebaseApp.firestore();

export { db };
